import template from './ranks_page.html'

export default {
  template,
  controller: 'ranksPageController as ranksPage'
}
